import request from "@/utils/request";

/** Les demandes déjà résolues qui ressemblent à celle-ci. */
export function listResolutionsProches(id) {
    return request.get(`/api/tickets/${id}/resolutions-proches`);
}

/** Les comptes probables pour ce ticket, déduits des coordonnées du demandeur. */
export function listComptesProbables(id) {
    return request.get(`/api/tickets/${id}/comptes-probables`);
}

/** Les chiffres du support sur une période, dans le périmètre de l'agent. */
export function statistiques(params) {
    return request.get("/api/tickets-statistiques", { params });
}

/**
 * La réponse que l'assistant propose. Lecture seule : rien n'est écrit sur le ticket, c'est
 * l'agent qui reprend le texte et l'envoie.
 */
export function propositionReponse(id, params) {
    return request.get(`/api/tickets/${id}/proposition-reponse`, { params });
}

/** Les réponses types utilisables sur ce ticket, variables déjà remplies par le serveur. */
export function listGabarits(id) {
    return request.get(`/api/tickets/${id}/gabarits`);
}

export function listGuichets() {
    return request.get("/api/ticket-guichets");
}

export function listTickets(params) {
    return request.get("/api/tickets", { params });
}

export function getTicket(id) {
    return request.get(`/api/tickets/${id}`);
}

export function createTicket(data) {
    return request.post("/api/tickets", data);
}

export function updateTicket(id, data) {
    return request.patch(`/api/tickets/${id}`, data);
}

export function assignerTicket(id, data) {
    return request.post(`/api/tickets/${id}/assigner`, data);
}

export function changerStatut(id, statut) {
    return request.post(`/api/tickets/${id}/statut`, { statut });
}

export function cloturerTicket(id, data) {
    return request.post(`/api/tickets/${id}/cloturer`, data);
}

/** L'agent a ouvert la demande : la pastille « non lu » s'éteint pour lui seul. */
export function marquerTicketLu(id) {
    return request.post(`/api/tickets/${id}/lu`);
}

export function rouvrirTicket(id) {
    return request.post(`/api/tickets/${id}/rouvrir`);
}

export function listMessages(id) {
    return request.get(`/api/tickets/${id}/messages`);
}

export function addMessage(id, data) {
    return request.post(`/api/tickets/${id}/messages`, data);
}

export function uploadPieceJointe(id, messageId, fichier) {
    const formData = new FormData();
    formData.append("fichier", fichier);
    return request.post(`/api/tickets/${id}/messages/${messageId}/pieces-jointes`, formData);
}

export function downloadPieceJointe(id, pieceId) {
    return request.get(`/api/tickets/${id}/pieces-jointes/${pieceId}`, { responseType: "blob" });
}

export function listParticipants(id) {
    return request.get(`/api/tickets/${id}/participants`);
}

export function addParticipant(id, data) {
    return request.post(`/api/tickets/${id}/participants`, data);
}

export function removeParticipant(id, participantId) {
    return request.delete(`/api/tickets/${id}/participants/${participantId}`);
}

/** Les agents à qui ce ticket peut être confié : ceux qui lisent son guichet. */
export function listAgents(id, params) {
    return request.get(`/api/tickets/${id}/agents`, { params });
}

export function listServices(id) {
    return request.get(`/api/tickets/${id}/services`);
}

/**
 * Les services du compte du ticket qui ne lui sont pas encore rattachés DANS CE RÔLE.
 * `params` : `role` (requis, signale | en_cause), `q` (facultatif).
 */
export function listServicesDisponibles(id, params) {
    return request.get(`/api/tickets/${id}/services-disponibles`, { params });
}

export function addService(id, data) {
    return request.post(`/api/tickets/${id}/services`, data);
}

export function removeService(id, lienId) {
    return request.delete(`/api/tickets/${id}/services/${lienId}`);
}
